import { useEffect, useRef, useState } from "react";
import { Banner, PartnerCards, PartnerForm } from "../components";
import { tracking } from '../utils/tracking';
import { imgs } from "../assets/imgs";
import { useResizeImg } from '../hooks/useResizeImg';
import { updateTags } from "../utils/funcs";


export const Partners = () => {
   const [isLoading, setIsLoading] = useState(true);
   const scrollRef = useRef(null);
   const imageSource = useResizeImg(imgs.partners.partnersBannerDesktop, imgs.partners.partnersBannerMobile)

   useEffect(() => {
      updateTags("Venture Summit West | Partners")
  }, [])

   return (
      <div className='partners'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1 >Partners</h1>
               <h2 >Why Partner with us?</h2>
               <h4>
                  Exposure &nbsp;<span >&gt;</span>&nbsp; Value &nbsp; <span >&gt;</span>&nbsp; Recognition
               </h4>
            </section>
            <section>
               <button onClick={() => { tracking(291); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }} className="btn">Request Info</button>
            </section>
         </Banner>
         <PartnerCards />
         <div ref={scrollRef} style={{ height: '50px', width: '100%' }} />
         {/* <PartnerForm /> */}
      </div>
   )
}
